/* Gift Shop Kawaii — theme.js */
(function () {
  'use strict';
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var safe = function (name, fn) { try { fn(); } catch (err) { if (window.console) console.error('[GSK] ' + name, err); } };
  document.documentElement.classList.remove('no-js');

  /* Precio con el mismo formato que Shopify */
  var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount_no_decimals}}';
  function fmtNum(cents, dec, th, dc) {
    var parts = (cents / 100).toFixed(dec).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
    return whole + (parts[1] ? dc + parts[1] : '');
  }
  var money = function (cents) {
    cents = Math.round(cents || 0);
    var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/); var key = m ? m[1] : 'amount'; var v;
    switch (key) {
      case 'amount_no_decimals': v = fmtNum(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmtNum(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmtNum(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmtNum(cents, 2, '\'', '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fmtNum(cents, 0, ' ', ','); break;
      case 'amount_with_space_separator': v = fmtNum(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = fmtNum(cents, 2, ' ', '.'); break;
      default: v = fmtNum(cents, 2, ',', '.');
    }
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, v);
  };
  var esc = function (s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\x22/g, '&quot;'); };
  var routes = window.routes || {};
  routes.root = routes.root || '/'; routes.cart_add_url = routes.cart_add_url || '/cart/add'; routes.cart_change_url = routes.cart_change_url || '/cart/change';
  routes.cart_url = routes.cart_url || '/cart'; routes.predictive_search_url = routes.predictive_search_url || '/search/suggest'; routes.search_url = routes.search_url || '/search';

  /* Toast */
  var toastTimer;
  function toast(msg) {
    var t = $('#Toast'); if (!t || !msg) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 3500);
  }

  /* Paneles laterales */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    $$('[aria-controls=' + id + ']').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { var f = $('.drawer__panel [data-drawer-close]', d); if (f) f.focus(); }, 60);
    return true;
  }
  function closeDrawers() {
    var open = $$('.drawer.is-open'); if (!open.length) return;
    open.forEach(function (d) {
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
      $$('[aria-controls=' + d.id + ']').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) {
      var id = o.getAttribute('data-drawer-open');
      if (id === 'CartDrawer' && (!document.getElementById('CartDrawer') || document.body.classList.contains('template-cart'))) return;
      e.preventDefault(); openDrawer(id); return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawers(); closePredictive(); } });

  /* ---------- Carrito ---------- */
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.setAttribute('data-count', n);
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  }
  function renderDrawer(html) {
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('CartDrawerInner');
    var cur = document.getElementById('CartDrawerInner');
    if (!fresh || !cur) return false;
    cur.replaceWith(fresh);
    var src = doc.querySelector('[data-cart-count-src]');
    if (src) updateCount(src.textContent.trim());
    return true;
  }
  function fetchDrawer() {
    var base = routes.root && routes.root !== '/' ? routes.root : '/';
    return fetch(base + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { return renderDrawer(j && j['cart-drawer']); });
  }
  function permalink(id, qty) { return routes.cart_add_url + '?id=' + encodeURIComponent(id) + '&quantity=' + (qty || 1); }

  var adding = false;
  function setLoading(els, on) {
    els.forEach(function (b) { b.classList.toggle('is-loading', on); if (b.tagName === 'A') b.style.opacity = on ? '.55' : ''; });
  }
  /* Agrega al carrito. Si algo falla, usa el enlace directo /cart/add?id=... que siempre funciona. */
  function addToCart(id, qty, props, els) {
    if (!id || adding) return;
    adding = true;
    qty = Math.max(1, parseInt(qty, 10) || 1);
    var fallback = function () { window.location.href = permalink(id, qty); };
    var finished = false;
    var done = function () { finished = true; adding = false; setLoading(els, false); };
    if (!window.fetch || !window.JSON) { fallback(); return; }
    setLoading(els, true);
    var timer = setTimeout(function () { if (!finished) { done(); fallback(); } }, 9000);
    var item = { id: parseInt(id, 10), quantity: qty };
    if (props && Object.keys(props).length) item.properties = props;
    fetch(routes.cart_add_url + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [item] })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (d) { clearTimeout(timer); done(); toast((d && (d.description || d.message)) || 'No pudimos agregarlo.'); }, function () { clearTimeout(timer); done(); fallback(); });
      }
      try { document.dispatchEvent(new CustomEvent('gsk:added', { detail: { id: String(id), qty: qty } })); } catch (err) {}
      if (document.body.classList.contains('template-cart')) { clearTimeout(timer); done(); window.location.reload(); return; }
      return fetchDrawer().then(function (ok) {
        clearTimeout(timer); done();
        if (ok && openDrawer('CartDrawer')) toast('Agregado al carrito');
        else window.location.href = routes.cart_url;
      }, function () { clearTimeout(timer); done(); window.location.href = routes.cart_url; });
    }).catch(function (err) { if (window.console) console.error('[GSK] add', err); clearTimeout(timer); done(); fallback(); });
  }

  /* Captura en window: el theme maneja los botones antes que cualquier app */
  window.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var q = e.target.closest('[data-quick-add]');
    if (q) {
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      addToCart(q.getAttribute('data-quick-add'), 1, null, [q]);
      return;
    }
    var t = e.target.closest('[data-add-trigger]');
    if (t) {
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (t.disabled) return;
      var form = document.getElementById('ProductForm');
      if (!form) return;
      var idEl = form.querySelector('[name=id]');
      var qtyEl = form.querySelector('[name=quantity]');
      if (qtyEl) clampQty(qtyEl);
      var props = {};
      $$('[name^=properties]', form).forEach(function (p) {
        if (p.disabled || !p.value) return;
        var k = p.name.replace(/^properties\[/, '').replace(/\]$/, ''); props[k] = p.value;
      });
      addToCart(idEl ? idEl.value : null, qtyEl ? qtyEl.value : 1, props, $$('[data-add-trigger]'));
    }
  }, true);

  function changeLine(line, quantity) {
    var inner = document.getElementById('CartDrawerInner');
    if (inner) inner.classList.add('is-busy');
    fetch(routes.cart_change_url + '.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      if (data && data.status && data.status !== 200) toast(data.description || data.message);
      return fetchDrawer().then(function (ok) { if (!ok) window.location.reload(); });
    }).catch(function () { window.location.reload(); });
  }
  /* Tope de stock en líneas del carrito */
  function lineMax(li) { var m = li.getAttribute('data-line-max'); return m === null || m === '' ? null : parseInt(m, 10); }
  function maxMsg(n) { return n === 1 ? 'Solo queda 1 unidad disponible' : 'Solo hay ' + n + ' unidades disponibles'; }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-qty]'); if (!b) return;
    if (b.disabled) return;
    var li = b.closest('[data-line]'); if (!li) return;
    var q = Math.max(0, parseInt(b.getAttribute('data-line-qty'), 10));
    var mx = lineMax(li);
    if (mx !== null && q > mx) { toast(maxMsg(mx)); b.disabled = true; return; }
    changeLine(parseInt(li.getAttribute('data-line'), 10), q);
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-line-input]'); if (!i) return;
    var li = i.closest('[data-line]');
    var q = Math.max(0, parseInt(i.value || '0', 10) || 0);
    var mx = lineMax(li);
    if (mx !== null && q > mx) { q = mx; i.value = mx; toast(maxMsg(mx)); }
    changeLine(parseInt(li.getAttribute('data-line'), 10), q);
  });

  /* Cantidad +/- en ficha, con tope de stock */
  function getMax(input) { var m = input.getAttribute('max'); return m === null || m === '' ? null : parseInt(m, 10); }
  function syncQty(input) {
    var wrap = input.closest('.qty'); if (!wrap) return;
    var min = parseInt(input.min || '1', 10);
    var mx = getMax(input);
    var v = parseInt(input.value, 10) || min;
    var plus = $('[data-qty=plus]', wrap), minus = $('[data-qty=minus]', wrap);
    var atMax = mx !== null && v >= mx;
    if (plus) plus.disabled = atMax || (mx !== null && mx <= 0);
    if (minus) minus.disabled = v <= min;
    var form = input.closest('form'); var hint = form ? $('[data-qty-hint]', form) : null;
    if (hint && !hint.hasAttribute('data-locked')) {
      if (atMax && mx > 0) {
        var inCart = parseInt(input.getAttribute('data-in-cart') || '0', 10);
        hint.textContent = inCart > 0
          ? 'Ya tienes ' + inCart + ' en tu carrito. Puedes agregar ' + (mx === 1 ? '1 unidad más.' : 'hasta ' + mx + ' más.')
          : (mx === 1 ? 'Solo queda 1 unidad disponible.' : 'Máximo disponible: ' + mx + ' unidades.');
        hint.hidden = false;
      } else { hint.hidden = true; }
    }
  }
  function clampQty(input) {
    var min = parseInt(input.min || '1', 10);
    var mx = getMax(input);
    var v = parseInt(input.value, 10);
    if (isNaN(v)) v = min;
    if (mx !== null && v > mx) v = Math.max(min, mx);
    if (v < min) v = min;
    input.value = v;
    syncQty(input);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]'); if (!b || b.disabled) return;
    var input = $('input', b.closest('.qty')); if (!input) return;
    input.value = (parseInt(input.value || '1', 10) || 1) + (b.getAttribute('data-qty') === 'plus' ? 1 : -1);
    clampQty(input);
  });
  document.addEventListener('input', function (e) {
    var i = e.target.closest('[data-qty-input]'); if (!i) return;
    var mx = getMax(i); var v = parseInt(i.value, 10);
    if (mx !== null && !isNaN(v) && v > mx) i.value = Math.max(1, mx);
    syncQty(i);
  });
  document.addEventListener('change', function (e) { var i = e.target.closest('[data-qty-input]'); if (i) clampQty(i); });

  /* Encabezado */
  var header = $('[data-header]');
  var headerWrap = header ? (header.closest('.section-header') || header) : null;
  function setHeaderH() { if (headerWrap) document.documentElement.style.setProperty('--header-h', headerWrap.offsetHeight + 'px'); }
  safe('header', function () {
    setHeaderH(); window.addEventListener('resize', setHeaderH);
    window.addEventListener('scroll', function () { if (header) header.classList.toggle('is-scrolled', window.scrollY > 8); }, { passive: true });
  });

  /* Búsqueda predictiva */
  var pTimer, pCtrl;
  function closePredictive() { var r = $('[data-predictive-results]'); if (r) r.hidden = true; }
  safe('predictive', function () {
    var pWrap = $('[data-predictive]'); if (!pWrap || !window.fetch) return;
    var pInput = $('[data-predictive-input]', pWrap), pBox = $('[data-predictive-results]', pWrap);
    if (!pInput || !pBox) return;
    pInput.addEventListener('input', function () {
      clearTimeout(pTimer);
      var q = pInput.value.trim();
      if (q.length < 2) { pBox.hidden = true; return; }
      pTimer = setTimeout(function () {
        if (pCtrl && pCtrl.abort) pCtrl.abort();
        pCtrl = window.AbortController ? new AbortController() : null;
        var url = routes.predictive_search_url + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, pCtrl ? { signal: pCtrl.signal } : {}).then(function (r) { return r.json(); }).then(function (j) {
          var items = (j.resources && j.resources.results && j.resources.results.products) || [];
          var all = '<a class=predictive__all href=' + routes.search_url + '?type=product&q=' + encodeURIComponent(q) + '>Ver todos los resultados para “' + esc(q) + '”</a>';
          pBox.innerHTML = items.length ? items.map(function (p) {
            var img = p.image || (p.featured_image && p.featured_image.url) || '';
            if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
            var price = p.price ? money(Math.round(parseFloat(p.price) * 100)) : '';
            return '<a class=predictive__item href=' + esc(p.url) + '>' + (img ? '<img src=' + esc(img) + ' alt=\x22\x22 width=52 height=52 loading=lazy>' : '<span></span>') + '<span class=predictive__title>' + esc(p.title) + '</span><span class=predictive__price>' + price + '</span></a>';
          }).join('') + all : '<p class=predictive__empty>No encontramos resultados para “' + esc(q) + '”.</p>';
          pBox.hidden = false;
        }).catch(function () {});
      }, 220);
    });
    pInput.addEventListener('focus', function () { if (pBox.innerHTML.trim() && pInput.value.trim().length > 1) pBox.hidden = false; });
    document.addEventListener('click', function (e) { if (!pWrap.contains(e.target)) pBox.hidden = true; });
  });

  /* Ficha de producto */
  $$('[data-product]').forEach(function (root) {
    safe('product', function () {
      var jsonEl = $('[data-product-json]', root); if (!jsonEl) return;
      var product = JSON.parse(jsonEl.textContent);
      var form = $('#ProductForm');
      var idInput = form ? $('input[name=id]', form) : null;
      var qtyInput = form ? $('[name=quantity]', form) : null;
      var hintEl = form ? $('[data-qty-hint]', form) : null;
      var priceEl = $('[data-price]', root);
      var addBtn = $('[data-add-btn]', root);
      var stockEl = $('[data-stock]', root);
      var invEl = $('[data-inv]', root);
      var inv = {};
      try { inv = invEl ? JSON.parse(invEl.textContent) : {}; } catch (err) { inv = {}; }
      var limits = {};
      try { var lm = $('[data-max-map]', root); limits = lm ? JSON.parse(lm.textContent) : {}; } catch (err) { limits = {}; }
      var lowAt = stockEl ? parseInt(stockEl.getAttribute('data-low') || '3', 10) : 3;
      var stockText = stockEl ? stockEl.getAttribute('data-text') : '';
      var slides = $('[data-slides]', root);
      var thumbs = $$('[data-thumb]', root);
      var dots = $$('.pdp__dots span', root);
      var sticky = $('[data-sticky-buy]');
      var stickyPrice = $('[data-sticky-price]');
      var stickyBtn = $('[data-sticky-add]');
      var currentV = null;

      function goTo(i, smooth) { if (slides) slides.scrollTo({ left: slides.clientWidth * i, behavior: smooth === false ? 'auto' : 'smooth' }); }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); }); });
      if (slides) slides.addEventListener('scroll', function () {
        var i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }, { passive: true });

      /* Aplica el tope de stock de la variante elegida */
      function applyLimit(v) {
        if (!qtyInput || !v) return;
        var L = limits[v.id] || limits[String(v.id)];
        var mx = L && typeof L.max === 'number' ? L.max : null;
        var inCart = L && typeof L.cart === 'number' ? L.cart : 0;
        qtyInput.setAttribute('data-in-cart', inCart);
        if (mx === null) qtyInput.removeAttribute('max'); else qtyInput.setAttribute('max', Math.max(mx, 0));
        var full = v.available && mx !== null && mx <= 0;
        var label = addBtn ? $('[data-add-label]', addBtn) : null;
        if (full) {
          if (addBtn) addBtn.disabled = true;
          if (label) label.textContent = 'Máximo en tu carrito';
          if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Máximo'; }
          if (hintEl) { hintEl.setAttribute('data-locked', ''); hintEl.textContent = 'Ya tienes en tu carrito todas las unidades disponibles.'; hintEl.hidden = false; }
          qtyInput.value = 1;
          var p = $('[data-qty=plus]', qtyInput.closest('.qty')); if (p) p.disabled = true;
          var mi = $('[data-qty=minus]', qtyInput.closest('.qty')); if (mi) mi.disabled = true;
          return;
        }
        if (hintEl) hintEl.removeAttribute('data-locked');
        if (v.available) {
          if (addBtn) addBtn.disabled = false;
          if (label) label.textContent = 'Agregar al carrito';
          if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = 'Agregar'; }
        }
        clampQty(qtyInput);
      }

      var groups = $$('[data-option-index]', root);
      function selected() { return groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; }); }
      function match(opts) { return product.variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0]; }
      function priceHTML(v) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        var pct = sale ? Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
        return '<span class=price__current>' + money(v.price) + '</span>' + (sale ? '<span class=price__compare>' + money(v.compare_at_price) + '</span><span class=\x22sticker sticker--sale\x22>-' + pct + '%</span>' : '');
      }
      function update(initial) {
        var opts = selected(); var v = match(opts);
        groups.forEach(function (g, gi) {
          $$('input', g).forEach(function (inp) {
            var test = opts.slice(); test[gi] = inp.value; var m = match(test);
            inp.classList.toggle('is-unavailable', !m || !m.available);
          });
          var l = $('[data-selected-label]', g); if (l) l.textContent = opts[gi] || '';
        });
        var label = addBtn ? $('[data-add-label]', addBtn) : null;
        if (!v) {
          if (addBtn) { addBtn.disabled = true; if (label) label.textContent = 'No disponible'; }
          if (stickyBtn) stickyBtn.disabled = true; return;
        }
        currentV = v;
        if (idInput) idInput.value = v.id;
        if (addBtn) { addBtn.disabled = !v.available; if (label) label.textContent = v.available ? 'Agregar al carrito' : 'Agotado'; }
        if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'Agregar' : 'Agotado'; }
        if (priceEl) { priceEl.innerHTML = priceHTML(v); priceEl.classList.toggle('price--sale', !!(v.compare_at_price > v.price)); }
        if (stickyPrice) stickyPrice.innerHTML = '<span class=price__current>' + money(v.price) + '</span>';
        if (stockEl) {
          stockEl.hidden = !v.available;
          var q = inv[v.id]; var isLow = typeof q === 'number' && q > 0 && q <= lowAt;
          stockEl.classList.toggle('stock--low', isLow);
          stockEl.textContent = isLow ? '¡Quedan solo ' + q + '!' : stockText;
        }
        if (!initial && qtyInput) qtyInput.value = 1;
        applyLimit(v);
        if (v.featured_media && slides) {
          var idx = $$('.pdp__slide', slides).map(function (s) { return s.getAttribute('data-media-id'); }).indexOf(String(v.featured_media.id));
          if (idx > -1) goTo(idx, !initial);
        }
        if (!initial) { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString()); }
      }
      groups.forEach(function (g) { g.addEventListener('change', function () { update(false); }); });
      if (groups.length) update(true);
      else if (idInput) {
        currentV = product.variants.filter(function (x) { return String(x.id) === String(idInput.value); })[0] || product.variants[0];
        applyLimit(currentV);
      }

      /* Al agregar, descuenta del tope lo que ya quedó en el carrito */
      document.addEventListener('gsk:added', function (ev) {
        var d = ev.detail || {}; var L = limits[d.id];
        if (!L) return;
        L.cart = (L.cart || 0) + d.qty;
        if (typeof L.max === 'number') L.max = Math.max(0, L.max - d.qty);
        if (qtyInput) qtyInput.value = 1;
        if (currentV && String(currentV.id) === d.id) applyLimit(currentV);
      });

      var gift = $('[data-gift]', root);
      if (gift) {
        var cb = $('[data-gift-toggle]', gift);
        var fields = $$('.gift__fields input, .gift__fields textarea', gift);
        var sync = function () { gift.classList.toggle('is-open', cb.checked); fields.forEach(function (f) { f.disabled = !cb.checked; }); };
        cb.addEventListener('change', sync); sync();
      }

      if (sticky && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0]; sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(addBtn);
      }
    });
  });

  /* Carruseles */
  function initRails(scope) {
    var scopes = $$('[data-rail-scope]', scope);
    if (scope && scope.matches && scope.matches('[data-rail-scope]')) scopes.push(scope);
    scopes.forEach(function (s) {
      var rail = $('[data-rail]', s); if (!rail) return;
      var step = function () { var li = rail.firstElementChild; return li ? li.getBoundingClientRect().width + 16 : rail.clientWidth; };
      $$('[data-rail-prev]', s).forEach(function (b) { b.onclick = function () { rail.scrollBy({ left: -step() * 2, behavior: 'smooth' }); }; });
      $$('[data-rail-next]', s).forEach(function (b) { b.onclick = function () { rail.scrollBy({ left: step() * 2, behavior: 'smooth' }); }; });
    });
  }

  /* Animación de entrada */
  function reveal(scope) {
    var els = $$('.reveal:not(.is-in)', scope);
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (ens) {
      ens.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (el, i) { el.style.transitionDelay = (i % 4) * 70 + 'ms'; io.observe(el); });
  }

  function initPage() {
    safe('rails', function () { initRails(document); });
    safe('reveal', function () { reveal(document); });
    safe('recs', function () {
      $$('[data-recs]').forEach(function (el) {
        var url = el.getAttribute('data-url'); if (!url) return;
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html');
          var fresh = d.querySelector('[data-recs]');
          if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initRails(el); reveal(el); }
        }).catch(function () {});
      });
    });
    safe('announce', function () {
      $$('[data-announce]').forEach(function (a) {
        var msgs = $$('.announce__msg', a); if (msgs.length < 2) return;
        var i = 0; var ms = parseInt(a.getAttribute('data-speed') || '5', 10) * 1000;
        setInterval(function () { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, ms);
      });
    });
    safe('sort', function () {
      $$('[data-sort]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var u = new URL(window.location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page');
          window.location.href = u.toString();
        });
      });
    });
    safe('seo', function () {
      $$('[data-seo-text]').forEach(function (w) {
        var b = $('[data-seo-toggle]', w), body = $('.seo-text__body', w); if (!b || !body) return;
        if (body.scrollHeight <= body.clientHeight + 10) { b.hidden = true; w.classList.add('is-open'); return; }
        b.addEventListener('click', function () {
          var o = w.classList.toggle('is-open'); b.textContent = o ? 'Leer menos' : 'Leer más'; b.setAttribute('aria-expanded', o);
        });
      });
    });
    safe('delivery', function () {
      var deliveryEls = $$('[data-delivery]'); if (!deliveryEls.length) return;
      var DAYS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
      var WD = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      var renderDelivery = function () {
        var now;
        try {
          var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Santiago', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
          var get = function (t) { return (parts.filter(function (p) { return p.type === t; })[0] || {}).value; };
          now = { day: WD[get('weekday')], minutes: parseInt(get('hour'), 10) * 60 + parseInt(get('minute'), 10) };
        } catch (e) { return; }
        deliveryEls.forEach(function (el) {
          var cutoff = parseInt(el.getAttribute('data-cutoff') || '0', 10) * 60; if (!cutoff) return;
          var sat = el.getAttribute('data-saturday') === 'true';
          var isShip = function (d) { return d >= 1 && d <= (sat ? 6 : 5); };
          if (isShip(now.day) && now.minutes < cutoff) {
            var left = cutoff - now.minutes, h = Math.floor(left / 60), m = left % 60;
            el.innerHTML = 'Compra en las próximas <span class=countdown>' + (h ? h + ' h ' : '') + m + ' min</span> y sale hoy.';
          } else {
            var d = now.day, add = 0; do { d = (d + 1) % 7; add++; } while (!isShip(d));
            el.innerHTML = 'Sale en el despacho <span class=countdown>' + (add === 1 ? 'de mañana' : 'del ' + DAYS[d]) + '</span>.';
          }
        });
      };
      renderDelivery(); setInterval(renderDelivery, 30000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPage); else initPage();

  document.addEventListener('shopify:section:load', function (e) {
    $$('.reveal', e.target).forEach(function (el) { el.classList.add('is-in'); });
    safe('rails', function () { initRails(e.target); }); setHeaderH();
  });
})();
